import React from 'react';
import { Search, Navigation, Crosshair } from 'lucide-react';

interface SearchControlsProps {
  searchQuery: string;
  coordinates: string;
  onSearchQueryChange: (query: string) => void;
  onCoordinatesChange: (coords: string) => void;
  onSearch: (e: React.FormEvent) => void;
  onCoordinatesSubmit: (e: React.FormEvent) => void;
  onMyLocationClick: () => void;
}

export const SearchControls: React.FC<SearchControlsProps> = ({
  searchQuery,
  coordinates,
  onSearchQueryChange,
  onCoordinatesChange,
  onSearch,
  onCoordinatesSubmit,
  onMyLocationClick
}) => {
  return (
    <div className="space-y-2 p-4 bg-white rounded-t-xl">
      <div className="flex gap-2">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => onSearchQueryChange(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && onSearch(e)}
            placeholder="Пошук па адрасе..."
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-primary focus:border-primary"
          />
        </div>
        <button
          onClick={onSearch}
          type="button"
          className="px-6 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 flex items-center gap-2"
        >
          <Search size={20} />
          <span className="hidden sm:inline">Знайсці</span>
        </button>
        <button
          onClick={onMyLocationClick}
          type="button"
          className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 flex items-center gap-2"
          title="Маё месцазнаходжанне"
        >
          <Crosshair size={20} className="text-primary" />
        </button>
      </div>

      <div className="flex gap-2">
        <input
          type="text"
          value={coordinates}
          onChange={(e) => onCoordinatesChange(e.target.value)}
          onKeyPress={(e) => e.key === 'Enter' && onCoordinatesSubmit(e)}
          placeholder="Каардынаты (шырата, даўгата)"
          className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-primary focus:border-primary"
        />
        <button
          onClick={onCoordinatesSubmit}
          type="button"
          className="px-6 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 flex items-center gap-2"
        >
          <Navigation size={20} />
          <span className="hidden sm:inline">Усталяваць</span>
        </button>
      </div>
    </div>
  );
};